import { scroll } from './scroll-to';

function getScrollParent(node) {
  if (node == null) {
    return null;
  }
  if (node.scrollHeight > node.clientHeight) {
    return node;
  }
  return getScrollParent(node.parentNode);
}

export default (form) => {
  const success = form.querySelector('[data-success-message]');
  const error = form.querySelector('[data-error-message]');
  success.classList.add('alert-message_hidden');
  error.classList.add('alert-message_hidden');

  let scroller = getScrollParent(form);
  if (scroller === document.body) {
    scroller = undefined;
  }

  fetch(form.getAttribute('action'), { method: 'post', body: new FormData(form) })
    .then((res) => {
      const message = res.ok ? success : error;
      message.classList.remove('alert-message_hidden');
      scroll(message.offsetTop, scroller);
      if (res.ok) {
        form.reset();
      }
    }, () => {
      error.classList.remove('alert-message_hidden');
      scroll(error.offsetTop, scroller);
    });
};
